/*tslint:disable*/
/*eslint-disable*/
//This file was automatically generated and should not be edited.
import gql from 'graphql-tag';
import { Fragment_CourseCard } from './Fragment_CourseCard';
export const Fragment_CourseCardBigThumb = gql`
  fragment Fragment_CourseCardBigThumb on Course {
    ...Fragment_CourseCard
    big_thumb: square_image(params: { width: 500, format: webp }) {
      processed_url
    }
  }
  ${Fragment_CourseCard}
`;
